import { useMemo } from 'react';
import { useGeneralRoutes, useSportsSettings } from '@namespace/cms';
import { encodeObjToUriParam } from '@namespace/helpers';

const isPandaScoreUrl = (
  statUrl: string,
  pandascoreUrls: string[],
  pandascoreUserName: string
): boolean =>
  Boolean(pandascoreUserName) &&
  pandascoreUrls?.some((url) => statUrl?.includes(url));

export const useGetPandascorePageUrl = (srcUrl: string): string => {
  const { pandascoreUserName, pandascoreUrls } = useSportsSettings();
  const { sportsStatistics } = useGeneralRoutes();

  return useMemo(() => {
    if (!isPandaScoreUrl(srcUrl, pandascoreUrls, pandascoreUserName)) {
      return srcUrl;
    }

    const data = encodeObjToUriParam({ src: srcUrl });
    if (!data) {
      console.error('Error encoding statistics url.');
      return '';
    }
    return `${sportsStatistics}?data=${data}`;
  }, [pandascoreUrls, pandascoreUserName, sportsStatistics, srcUrl]);
};
